<div class="view-wrapper">
  <dx-toolbar class="theme-dependent" [class.scrolled]="isContentScrolled">
    <dxi-item location="before">
      <div class="header-text">Substance Abuse Treatment Referral</div>
    </dxi-item>
    @if (!isLoading() && isEditing()) {
    <dxi-item location="after" locateInMenu="never">
      <dx-button text="Submit" type="default" stylingMode="contained" (onClick)="submit()"></dx-button>
    </dxi-item>
    } @if (!isLoading() && !isEditing()) {
    <dxi-item location="after" locateInMenu="never">
      <form-export [fileName]="'sat-referral'" [dataSource]="[model()]"></form-export>
    </dxi-item>
    }
  </dx-toolbar>

  <dx-scroll-view class="view-wrapper-scroll" (onScroll)="scroll($event)">
    <dx-validation-group #validationGroup>
      @if (model()) { @if (!isEditing()) {
      <app-form-note [formName]="Forms.SatReferral" [formId]="key()"></app-form-note>
      }

      <div class="cards-container">
        <card class="profile-card">
          <dx-form
            *ngIf="model"
            class="form last plain-styled-form"
            [formData]="model"
            labelMode="floating"
            [class.view-mode]="!isEditing()"
          >
            <dxi-item itemType="group">
              <dxi-item>
                <form-item-date
                  *dxTemplate
                  label="Date"
                  [(value)]="model().date"
                  [isRequired]="true"
                  [isEditing]="isEditing()"
                ></form-item-date>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </card>
        <app-form-attachment #formAttachment [formName]="Forms.SatReferral" [formId]="key()" [isEditing]="isEditing()" />

        <card title="Offender" class="profile-card full-card">
          <dx-form class="form last plain-styled-form" [formData]="model" labelMode="floating" [class.view-mode]="!isEditing()">
            <dxi-item itemType="group" [colCount]="2">
              <dxi-item itemType="group">
                <dxi-item>
                  <form-textbox
                    *dxTemplate
                    label="Name"
                    [(value)]="model().offenderName"
                    [isRequired]="true"
                    [isEditing]="isEditing()"
                  ></form-textbox>
                </dxi-item>
                <dxi-item [colSpan]="2">
                  <form-textbox
                    *dxTemplate
                    label="Address"
                    [(value)]="model().offenderAddress"
                    [isRequired]="true"
                    [isEditing]="isEditing()"
                  ></form-textbox>
                </dxi-item>
                <dxi-item itemType="group" [colCount]="4">
                  <dxi-item [colSpan]="2">
                    <form-textbox
                      *dxTemplate
                      label="City"
                      [(value)]="model().offenderCity"
                      [isRequired]="true"
                      [isEditing]="isEditing()"
                    ></form-textbox>
                  </dxi-item>
                  <dxi-item>
                    <form-textbox
                      *dxTemplate
                      label="State"
                      [(value)]="model().offenderState"
                      [isRequired]="true"
                      [isEditing]="isEditing()"
                    ></form-textbox>
                  </dxi-item>
                  <dxi-item>
                    <form-textbox
                      *dxTemplate
                      label="Zip Code"
                      [(value)]="model().offenderZipCode"
                      [isRequired]="true"
                      [isEditing]="isEditing()"
                    ></form-textbox>
                  </dxi-item>
                </dxi-item>
              </dxi-item>
              <dxi-item itemType="group">
                <dxi-item>
                  <form-item-date
                    *dxTemplate
                    label="DOB"
                    [(value)]="model().offenderDateOfBirth"
                    [isRequired]="true"
                    [isEditing]="isEditing()"
                  ></form-item-date>
                </dxi-item>
                <dxi-item>
                  <form-textbox
                    *dxTemplate
                    label="Offender Number"
                    [(value)]="model().offenderNumber"
                    [isEditing]="isEditing()"
                  ></form-textbox>
                </dxi-item>

                <dxi-item>
                  <form-textbox
                    *dxTemplate
                    label="Phone"
                    [(value)]="model().offenderPhone"
                    [isRequired]="true"
                    [isEditing]="isEditing()"
                  ></form-textbox>
                </dxi-item>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </card>
      </div>

      <div class="cards-container">
        <card title="Supervising Agent" class="profile-card half-card">
          <dx-form class="form last plain-styled-form" [formData]="model" labelMode="floating" [class.view-mode]="!isEditing()">
            <dxi-item>
              <form-textbox
                *dxTemplate
                label="Name"
                [(value)]="model().supervisingAgentName"
                [isRequired]="true"
                [isEditing]="isEditing()"
              ></form-textbox>
            </dxi-item>
            <dxi-item>
              <form-textbox
                *dxTemplate
                [isEmail]="true"
                label="Email"
                [(value)]="model().supervisingAgentEmail"
                [isEditing]="isEditing()"
              ></form-textbox>
            </dxi-item>
            <dxi-item>
              <form-textbox *dxTemplate label="Phone" [(value)]="model().supervisingAgentPhone" [isEditing]="isEditing()"></form-textbox>
            </dxi-item>
          </dx-form>
        </card>
        <card title="Supervisor" class="profile-card half-card">
          <dx-form class="form last plain-styled-form" [formData]="model" labelMode="floating" [class.view-mode]="!isEditing()">
            <dxi-item>
              <form-textbox
                *dxTemplate
                label="Name"
                [(value)]="model().supervisorName"
                [isEditing]="isEditing()"
              ></form-textbox>
            </dxi-item>
            <dxi-item>
              <form-textbox
                *dxTemplate
                [isEmail]="true"
                label="Email"
                [(value)]="model().supervisorEmail"
                [isEditing]="isEditing()"
              ></form-textbox>
            </dxi-item>
            <dxi-item>
              <form-textbox *dxTemplate label="Phone" [(value)]="model().supervisorPhone" [isEditing]="isEditing()"></form-textbox>
            </dxi-item>
          </dx-form>
        </card>
      </div>

      <div class="cards-container">
        <card title="Primary" class="profile-card">
          <dx-form class="form last plain-styled-form" [formData]="model" labelMode="floating" [class.view-mode]="!isEditing()">
            <dxi-item>
              <form-selectbox
                *dxTemplate
                [items]="drugOptions"
                label="Drug of Choice"
                [(value)]="model().primaryDrug"
                [isRequired]="true"
                [isEditing]="isEditing()"
              ></form-selectbox>
            </dxi-item>
            <dxi-item itemType="empty" [visible]="model().primaryDrug !== 'Other'" [colSpan]="2"></dxi-item>
            <dxi-item [visible]="model().primaryDrug === 'Other'" [colSpan]="2">
              <form-textbox
                *dxTemplate
                label="Explain"
                [(value)]="model().primaryDrugOther"
                [isRequired]="true"
                [isEditing]="isEditing()"
              ></form-textbox>
            </dxi-item>
            <dxi-item>
              <form-selectbox
                *dxTemplate
                [items]="administrationMethodOptions"
                label="Route of Administration"
                [(value)]="model().primaryDrugAdministrationMethod"
                [isRequired]="true"
                [isEditing]="isEditing()"
              ></form-selectbox>
            </dxi-item>
            <dxi-item>
              <form-item-date
                *dxTemplate
                label="Date of Last Use"
                [(value)]="model().primaryDrugLastUse"
                [isRequired]="true"
                [isEditing]="isEditing()"
              ></form-item-date>
            </dxi-item>
            <dxi-item>
              <form-selectbox
                *dxTemplate
                [items]="frequencyOptions"
                label="Frequency of Use"
                [(value)]="model().primaryDrugFrequency"
                [isRequired]="true"
                [isEditing]="isEditing()"
              ></form-selectbox>
            </dxi-item>
          </dx-form>
        </card>
        <card title="Secondary" class="profile-card">
          <dx-form class="form last plain-styled-form" [formData]="model" labelMode="floating" [class.view-mode]="!isEditing()">
            <dxi-item>
              <form-selectbox
                *dxTemplate
                [items]="drugOptions"
                label="Drug of Choice"
                [(value)]="model().secondaryDrug"
                [isEditing]="isEditing()"
              ></form-selectbox>
            </dxi-item>
            <dxi-item itemType="empty" [visible]="model().secondaryDrug !== 'Other'" [colSpan]="2"></dxi-item>
            <dxi-item [visible]="model().secondaryDrug === 'Other'" [colSpan]="2">
              <form-textbox
                *dxTemplate
                label="Explain"
                [(value)]="model().secondaryDrugOther"
                [isRequired]="true"
                [isEditing]="isEditing()"
              ></form-textbox>
            </dxi-item>
            <dxi-item [visible]="!!model().secondaryDrug">
              <form-selectbox
                *dxTemplate
                [items]="administrationMethodOptions"
                label="Route of Administration"
                [(value)]="model().secondaryDrugAdministrationMethod"
                [isRequired]="true"
                [isEditing]="isEditing()"
              ></form-selectbox>
            </dxi-item>
            <dxi-item [visible]="!!model().secondaryDrug">
              <form-item-date
                *dxTemplate
                label="Date of Last Use"
                [(value)]="model().secondaryDrugLastUse"
                [isRequired]="true"
                [isEditing]="isEditing()"
              ></form-item-date>
            </dxi-item>
            <dxi-item [visible]="!!model().secondaryDrug">
              <form-selectbox
                *dxTemplate
                [items]="frequencyOptions"
                label="Frequency of Use"
                [(value)]="model().secondaryDrugFrequency"
                [isRequired]="true"
                [isEditing]="isEditing()"
              ></form-selectbox>
            </dxi-item>
          </dx-form>
        </card>
      </div>

      <div class="cards-container">
        <card title="Substance Use Assessment" class="profile-card full-card">
          <dx-form class="form last plain-styled-form" [formData]="model" labelMode="floating" [class.view-mode]="!isEditing()">
            <dxi-item>The offender is unable to control their substance use as evidence by (check all that apply)</dxi-item>
            <dxi-item itemType="group" [colCount]="2">
              <dxi-item itemType="group">
                <dxi-item>
                  <form-checkbox
                    *dxTemplate
                    [(value)]="model().hasDesireForTreatment"
                    text="Offender has expressed desire for treatment"
                    [isEditing]="isEditing()"
                  ></form-checkbox>
                </dxi-item>
                <dxi-item>
                  <form-checkbox
                    *dxTemplate
                    [(value)]="model().hasRecentFailedSubstanceTest"
                    text="Two or more positive drug or alcohol tests within last six months"
                    [isEditing]="isEditing()"
                  ></form-checkbox>
                </dxi-item>
                <dxi-item>
                  <form-checkbox
                    *dxTemplate
                    [(value)]="model().hasFamilyExpressedConcern"
                    text="Family member has contacted agent to express concern regarding offender's substance abuse"
                    [isEditing]="isEditing()"
                  ></form-checkbox>
                </dxi-item>
                <dxi-item>
                  <form-checkbox
                    *dxTemplate
                    [(value)]="model().hasRecentFailedTreatment"
                    text="Unsuccessful termination from a substance abuse treatment program within the last six months"
                    [isEditing]="isEditing()"
                  ></form-checkbox>
                </dxi-item>
                <dxi-item [visible]="model().hasRecentFailedTreatment" [cssClass]="'sub-item'">
                  <form-item-date
                    *dxTemplate
                    label="Date"
                    [(value)]="model().recentFailedTreatmentDate"
                    [isRequired]="true"
                    [isEditing]="isEditing()"
                  ></form-item-date>
                </dxi-item>
              </dxi-item>
              <dxi-item itemType="group">
                <dxi-item>
                  <form-checkbox
                    *dxTemplate
                    [(value)]="model().hasRecentSubstanceArrest"
                    text="Recent arrest by criminal justice agency for use/possession of alcohol or controlled substance"
                    [isEditing]="isEditing()"
                  ></form-checkbox>
                </dxi-item>
                <dxi-item>
                  <form-checkbox
                    *dxTemplate
                    [(value)]="model().hasOtherSubstanceAbuseIssue"
                    text="Other"
                    [isEditing]="isEditing()"
                  ></form-checkbox>
                </dxi-item>
                <dxi-item [visible]="model().hasOtherSubstanceAbuseIssue" [cssClass]="'sub-item'">
                  <form-textbox
                    *dxTemplate
                    label="Explain"
                    [(value)]="model().otherSubstanceAbuseIssue"
                    [isRequired]="true"
                    [isEditing]="isEditing()"
                  ></form-textbox>
                </dxi-item>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </card>
      </div>

      <div class="cards-container">
        <card title="Previous Treatment" class="profile-card full-card">
          <dx-form
            class="form last plain-styled-form"
            [formData]="model"
            labelMode="floating"
            [colCount]="2"
            [class.view-mode]="!isEditing()"
          >
            <dxi-item itemType="group">
              <dxi-item>
                <form-checkbox
                  *dxTemplate
                  [(value)]="model().outpatientTreatmentReceived"
                  text="Outpatient"
                  [isEditing]="isEditing()"
                ></form-checkbox>
              </dxi-item>
              <dxi-item itemType="group" [colCount]="2" [visible]="model().outpatientTreatmentReceived" [cssClass]="'sub-item'">
                <dxi-item>
                  <form-numberbox
                    *dxTemplate
                    label="Number of times"
                    [(value)]="model().outpatientTreatmentAmount"
                    [isRequired]="true"
                    [isEditing]="isEditing()"
                  ></form-numberbox>
                </dxi-item>
                <dxi-item [visible]="model().outpatientTreatmentReceived">
                  <form-textbox
                    *dxTemplate
                    label="Dates (M/Y)"
                    [(value)]="model().outpatientTreatmentDates"
                    [isRequired]="true"
                    [isEditing]="isEditing()"
                  ></form-textbox>
                </dxi-item> </dxi-item
            ></dxi-item>
            <dxi-item itemType="group">
              <dxi-item>
                <form-checkbox
                  *dxTemplate
                  [(value)]="model().residentialTreatmentReceived"
                  text="Residential"
                  [isEditing]="isEditing()"
                ></form-checkbox>
              </dxi-item>
              <dxi-item itemType="group" [colCount]="2" [visible]="model().residentialTreatmentReceived" [cssClass]="'sub-item'">
                <dxi-item>
                  <form-numberbox
                    *dxTemplate
                    label="Number of times"
                    [(value)]="model().residentialTreatmentAmount"
                    [isRequired]="true"
                    [isEditing]="isEditing()"
                  ></form-numberbox>
                </dxi-item>
                <dxi-item [visible]="model().residentialTreatmentReceived">
                  <form-textbox
                    *dxTemplate
                    label="Dates (M/Y)"
                    [(value)]="model().residentialTreatmentDates"
                    [isRequired]="true"
                    [isEditing]="isEditing()"
                  ></form-textbox>
                </dxi-item>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </card>
      </div>

      <div class="cards-container">
        <card title="Offense History" class="profile-card full-card">
          <dx-form
            class="form last plain-styled-form"
            [colCount]="2"
            [formData]="model"
            labelMode="floating"
            [class.view-mode]="!isEditing()"
          >
            <dxi-item>
              <form-selectbox
                *dxTemplate
                [items]="offenseHistoryOptions"
                label="Offender has history/conviction for"
                [(value)]="model().otherOffenseHistory"
                [isEditing]="isEditing()"
              ></form-selectbox>
            </dxi-item>
          </dx-form>
        </card>
      </div>

      <div class="cards-container">
        <card title="Medical/Psychiatric History" class="profile-card full-card">
          <dx-form
            class="form last plain-styled-form"
            [formData]="model"
            labelMode="floating"
            [class.view-mode]="!isEditing()"
            [colCount]="2"
          >
            <dxi-item itemType="group">
              <dxi-item>
                <form-selectbox
                  *dxTemplate
                  [(value)]="model().currentMedicalCondition"
                  label="Current medical condition"
                  [items]="medicalConditionOptions"
                  [isEditing]="isEditing()"
                ></form-selectbox>
              </dxi-item>
              <dxi-item [visible]="model().currentMedicalCondition === 'Other'" [cssClass]="'sub-item'">
                <form-textbox
                  *dxTemplate
                  label="Explain"
                  [(value)]="model().currentMedicalConditionOther"
                  [isRequired]="true"
                  [isEditing]="isEditing()"
                ></form-textbox>
              </dxi-item>
              <dxi-item>
                <form-checkbox
                  *dxTemplate
                  [(value)]="model().psychiatricProblemsExist"
                  text="Current or previous psychiatric problems"
                  [isEditing]="isEditing()"
                ></form-checkbox>
              </dxi-item>
              <dxi-item [visible]="model().psychiatricProblemsExist" [cssClass]="'sub-item'">
                <form-textbox
                  *dxTemplate
                  label="Explain"
                  [(value)]="model().psychiatricProblemDetails"
                  [isRequired]="true"
                  [isEditing]="isEditing()"
                ></form-textbox>
              </dxi-item>
              <dxi-item>
                <form-checkbox *dxTemplate [(value)]="model().onMedication" text="On medications" [isEditing]="isEditing()"></form-checkbox>
              </dxi-item>
              <dxi-item [visible]="model().onMedication" [cssClass]="'sub-item'">
                <form-textbox
                  *dxTemplate
                  label="List"
                  [(value)]="model().medicationDetails"
                  [isRequired]="true"
                  [isEditing]="isEditing()"
                ></form-textbox>
              </dxi-item>
            </dxi-item>

            <dxi-item itemType="group">
              <dxi-item itemType="empty"></dxi-item>
              <dxi-item>
                <form-checkbox
                  *dxTemplate
                  [(value)]="model().medicationHasThirtyDaySupply"
                  text="30 Day Supply of Meds available"
                  [isEditing]="isEditing()"
                ></form-checkbox>
              </dxi-item>
              <dxi-item>
                <form-checkbox
                  *dxTemplate
                  [(value)]="model().medicationIsImmediatelyAvailable"
                  text="Medication immediately available"
                  [isEditing]="isEditing()"
                ></form-checkbox>
              </dxi-item>
              <dxi-item [visible]="!model().medicationIsImmediatelyAvailable">
                <form-item-date
                  *dxTemplate
                  label="Date medication is available"
                  [(value)]="model().medicationAvailableDate"
                  [isEditing]="isEditing()"
                ></form-item-date>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </card>
      </div>
      }
    </dx-validation-group>
  </dx-scroll-view>
</div>
